import CryptoJS from "crypto-js";
//随机生成指定数量的32进制key
export default {
  generatekey(num) {
    let library =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let key = "";
    for (let i = 0; i < num; i++) {
      let randomPoz = Math.floor(Math.random() * library.length);
      key += library.substring(randomPoz, randomPoz + 1);
    }
    return key;
  },
  //加密
  encrypt(words, keys) {
    let key = CryptoJS.enc.Utf8.parse(keys) // 十六位十六进制数作为密钥
    let word = CryptoJS.enc.Utf8.parse(words); //十六位十六进制数作为密钥偏移量
    let vi = CryptoJS.enc.Utf8.parse(keys) 
    let encrypted = CryptoJS.AES.encrypt(word, key, {
      iv: vi,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  },
  //解密
  decrypt(wordS, keys) {
    let key = CryptoJS.enc.Utf8.parse(keys) // 十六位十六进制数作为密钥
    let vi = CryptoJS.enc.Utf8.parse(keys) 
    let decrypt = CryptoJS.AES.decrypt(wordS, key, {
      iv: vi,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
};



// WEBPACK FOOTER //
// ./src/utils/AES.js